import React from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";
import { useState } from "react";
import NewPswdForm from "./NewPswdForm";
import coppelLogo from "../../assets/coppel.svg";
import coppelBckg from "../../assets/coppel-login-img.jpg";

const LoginComponent = () => {
  /** ESTADOS PARA MANEJAR LOS INPUTS */
  const [userInput, setUserInput] = useState({
    email: "",
    password: "",
  });
  const [recoveryEmail, setRecoveryEmail] = useState("");
  /** ESTADOS PARA MANEJAR EL LOADING Y LOS ERRORES */
  const [loading, setLoading] = useState(false);
  const [loadingRecovery, setLoadingRecovery] = useState(false);
  const [loginErr, setLoginErr] = useState("");
  const [recoveryError, setRecoveryError] = useState("");
  const [showRecovery, setShowRecovery] = useState(false);
  /** IMPORTAR NAVEGACION Y FUNCIONES DE AUTENTICACION */
  const navigate = useNavigate();
  const { signIn, resetPassword, newPswdRequired } = UserAuth();

  /** --------------------------------------------------------------- */
  /** FUNCIONES PARA INICIAR SESION */
  const handleChange = ({ target: { name, value } }) => {
    setUserInput({ ...userInput, [name]: value });
  };

  const translateError = (error) => {
    switch (error.code) {
      case 'InvalidParameterException':
        return 'Falta un parámetro requerido: Email';
      case 'NotAuthorizedException':
        return 'Email o contraseña incorrectos.';
      case 'UserNotFoundException':
        return 'Usuario no encontrado.';
      case 'PasswordResetRequiredException':
        return 'Es necesario restablecer la contraseña.';
      case 'UserNotConfirmedException':
        return 'El usuario no ha sido confirmado.';
      default:
        return 'Ocurrió un error inesperado. Por favor, inténtelo de nuevo.';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(async () => {
      signIn(userInput.email, userInput.password)
        .then(() => {
          navigate("/dashboard");
          setLoading(false);
        })
        .catch((err) => {
          setLoginErr(translateError(err));
          setLoading(false);
          setTimeout(() => {
            setLoginErr("");
          }, 10000);
        });
    }, 500);
  };

  /** FUNCIONES PARA RECUPERAR CONTRASEÑA */
  const handleRecoveryEmailChange = (e) => {
    setRecoveryEmail(e.target.value);
  };

  const handleRecovery = () => {
    setShowRecovery(!showRecovery);
  };

  const handleRecoverySubmit = (e) => {
    e.preventDefault();
    setLoadingRecovery(true);

    resetPassword(recoveryEmail)
      .then(() => {
        setLoadingRecovery(false);
        navigate("/");
      })
      .catch((err) => {
        setLoadingRecovery(false);
        setRecoveryError("Ocurrió un error. Por favor, inténtelo de nuevo.");
        setTimeout(() => {
          setRecoveryError("");
        }, 10000);
      });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  return (
    <>
      {newPswdRequired.required ? (
        <NewPswdForm email={userInput.email} />
      ) : !showRecovery ? (
        <div>
          <div className="flex h-screen bg-gray-100">
            {/* Image Container para mas tarde */}
            <div className="flex items-center justify-center w-1/2 h-full bg-white border-r">
              <img src={coppelBckg} className="object-cover w-full h-full" />
            </div>

            {/* <!-- Form Container --> */}
            <div className="flex justify-center w-1/2 pt-20 bg-white relative">
              <div>
                <div>
                  <img src={coppelLogo} />
                </div>
                <div className="mb-4">
                  {/*  Form Header */}
                  <h2 className="mb-2 text-4xl font-bold text-gray-700">
                    Accesa a tu dashboard
                  </h2>
                  <p className="text-center text-gray-500">
                    Captura tus datos para acceder a tu cuenta
                  </p>
                </div>

                {/*  Email Input */}
                <div className="mb-4">
                  <label className="block mb-2 text-sm text-left font-bold text-gray-700">
                    Email
                  </label>
                  <input
                    className="w-full px-3 py-2 leading-tight border rounded appearance-none focus:outline-none focus:shadow-outline"
                    id="email"
                    name="email"
                    type="email"
                    placeholder="ejemplo@dominio.com"
                    onChange={handleChange}
                    value={userInput.email}
                    onKeyDown={handleKeyPress}
                  />
                </div>

                {/*  Password Input  */}
                <div className="mb-6">
                  <label className="block mb-2 text-sm text-left font-bold text-gray-700">
                    Contraseña
                  </label>
                  <input
                    className="w-full px-3 py-2 mb-3 leading-tight border rounded appearance-none focus:outline-none focus:shadow-outline"
                    id="password"
                    name="password"
                    type="password"
                    placeholder="*******"
                    value={userInput.password}
                    onChange={handleChange}
                    onKeyDown={handleKeyPress}
                  />
                  <div className="flex justify-end">
                    <button
                      className="inline-block text-sm text-sky-600 align-baseline hover:text-sky-900"
                      onClick={handleRecovery}
                    >
                      ¿Olvidaste tu contraseña?
                    </button>
                  </div>
                </div>

                {/*  Submit Button */}
                <div className="flex flex-col items-center justify-between">
                  <button
                    className="w-full px-4 py-2 font-semibold text-white bg-sky-700 rounded hover:bg-sky-900 focus:outline-none focus:shadow-outline"
                    type="button"
                    onClick={handleSubmit}
                  >
                    {loading ? "Cargando..." : "Iniciar sesión"}
                  </button>
                  <div>
                    {loginErr ? (
                      <p className="py-2 font-semibold text-red-600">
                        {loginErr}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
                {/*  Footer */}
                <div className="text-center text-sky-900 font-semibold text-xl absolute bottom-0 pb-4">
                  Powered by Stratech
                </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-screen bg-gray-100">
          {/* <!-- Recovery Password Form --> */}
          <div className="flex flex-col items-center h-full pt-20">
            {/* <!-- Image Container --> */}
            <div className="w-full">
              <img src={coppelLogo} />
            </div>

            {/* <!-- Form Container --> */}
            <div className="px-8 max-w-md">
              <h2 className="w-full text-3xl font-bold mb-3 text-gray-700">
                Recupera tu contraseña
              </h2>
              <p className="text-gray-700 mb-10 text-left px-10">
                Ingresa el correo con el que te registraste para recuperar tu
                contraseña
              </p>

              {/* <!-- Email Input --> */}
              <form onSubmit={handleRecoverySubmit}>
                <div className="mb-12">
                  <label className="block text-gray-700 text-sm font-bold mb-2 text-left">
                    Email
                  </label>
                  <input
                    id="email"
                    type="email"
                    value={recoveryEmail}
                    onChange={handleRecoveryEmailChange}
                    placeholder="debra.holt@example.com"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-900 bg-transparent"
                  />
                </div>
                <div className="flex justify-center gap-12">
                  <button
                    className="bg-sky-600 hover:bg-blue-900 text-white py-2 px-6 rounded focus:outline-none focus:bg-blue-900"
                    onClick={() => setShowRecovery(false)}
                  >
                    Regresar
                  </button>
                  <button
                    type="submit"
                    className="bg-sky-700 hover:bg-blue-900 text-white py-2 px-8 rounded focus:outline-none focus:bg-blue-900"
                  >
                    {!loadingRecovery ? "Enviar" : "Cargando"}
                  </button>
                </div>
              </form>

              {/* <!-- Recovery Error Message --> */}
              {recoveryError ? (
                <p className="text-red-600 font-semibold py-2">
                  {recoveryError}
                </p>
              ) : (
                ""
              )}
            </div>
            {/* <!-- Powered by Stratech --> */}
            <p className="flex justify-center w-full items-center absolute bottom-0 text-center text-sky-900 font-bold text-2xl">
              Powered by Stratech
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginComponent;
